import React from 'react';
import Layout from './Hoc/Layout';
import { Switch, Route }  from 'react-router-dom';

import PrivateRoute from './Components/authRoutes/privateRoutes';
import PublicRoute from './Components/authRoutes/publicRoutes';

import Home from './Components/home';
import SignIn from './Components/signin';
import NotFound from './Components/ui/not_found';

import Dashboard from './Components/admin/Dashboard';
import Posts from './Components/admin/matches';
import User from './Components/admin/players';

const Routes = (props) => {
  return(
    <Layout>
        <Switch>
            {/* <PrivateRoute {...props} path="/admin_players/add_players" exact component={AddEditPlayers}/>
            <PrivateRoute {...props} path="/admin_players/add_players/:id" exact component={AddEditPlayers}/> 
            <PrivateRoute {...props} path="/admin_players" exact component={AdminPlayers}/>
            <PrivateRoute {...props} path="/admin_matches/edit_match" exact component={AddEditMatch}/>
            <PrivateRoute {...props} path="/admin_matches/edit_match/:id" exact component={AddEditMatch}/> 
            <PrivateRoute {...props} path="/admin_matches" exact component={AdminMatches}/> */}
            <PrivateRoute {...props} path="/user" exact component={User}/>
            <PrivateRoute {...props} path="/post" exact component={Posts}/> 
            <PrivateRoute {...props} path="/dashboard" exact component={Dashboard}/>
            {/* <PublicRoute {...props} restricted={true} path="/sign_in" exact component={SignIn}/> */}
            <PublicRoute {...props} restricted={false} path="/" exact component={SignIn}/>
            <PublicRoute {...props} restricted={false} component={NotFound}/>

        </Switch>
    </Layout>
  )
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js